import { render, staticRenderFns } from "./PracticeVtsCenterDetailsContent.vue?vue&type=template&id=93c76b08"
import script from "./PracticeVtsCenterDetailsContent.vue?vue&type=script&lang=ts"
export * from "./PracticeVtsCenterDetailsContent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports